import type { GlobalObjectType } from '@atlassian/preview-panel-global-objects/types';
import type { PanelProduct } from '@atlassian/preview-panels-api/types';

export const PANEL_PRODUCT: PanelProduct = 'confluencePreviewPanel';

export const PANEL_TYPE: GlobalObjectType = 'confluence-teamworkGraph';

export const PARENT_PRODUCT = 'confluence';

export const PANEL_ID_BASE = 'teamwork-graph-preview-panel';
